import { render } from "./BaseDialog.vue?vue&type=template&id=558fad42&scoped=true"
import script from "./BaseDialog.vue?vue&type=script&lang=js"
export * from "./BaseDialog.vue?vue&type=script&lang=js"

import "./BaseDialog.vue?vue&type=style&index=0&id=558fad42&scoped=true&lang=css"

import exportComponent from "D:\\Users\\וינברג\\Documents\\Vue\\main-prj-01-starting-setup\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-558fad42"]])

export default __exports__